import { boot, isEraroError, createEraroError } from '@dazn/bootstrap-lib';

import { SetCurrentChapter } from '../public-api/lib/SetCurrentChapter';

export const loadErrorChapter = (
    loadChapter: SetCurrentChapter,
    defaultCategory: string,
    defaultCode: string,
    defaultInternal: string,
    errorChapterName: boot.config.ChapterName,
    currentChapter: string,
    error: Error,
) => {
    const getEraro = () =>
        isEraroError(error)
            ? error
            : createEraroError(
                  'Unknown error',
                  defaultCategory,
                  defaultCode,
                  defaultInternal,
                  error,
              );
    const eraro = getEraro();

    const data = {
        errorCode: [eraro.category, eraro.code, eraro.internal].join('_'),
        chapter: currentChapter === 'unknown' ? undefined : currentChapter,
    };

    return loadChapter({
        chapterName: errorChapterName,
        chapterData: data,
    });
};
